export default "<p>\n  home works!\n  <a routerLink=\"/login\">Login</a>\n  <a routerLink=\"/admin\">Go to admin</a>\n</p>\n"